"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskListDescription = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Theme_1 = require("@amzn/atoz-web/Theme");
const TaskListDescriptionTypes_1 = require("./TaskListDescriptionTypes");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const BIAnalytics_1 = __importDefault(require("../../utils/BIAnalytics/BIAnalytics"));
const TaskListDescription = ({ description, descriptionTitle, descriptionFull }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const openModal = (open) => {
        var _a;
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.TASK_LIST_LEARN_MORE_CLICKED.COUNT,
            dimensions
        });
        (_a = BIAnalytics_1.default.clickTaskListLearnMore) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.default);
        open();
    };
    const renderModal = ({ close }) => (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: TaskListDescriptionTypes_1.DATA_TEST_IDS.TASK_LIST_DESCRIPTION_MODAL, titleText: descriptionTitle, buttons: [
            react_1.default.createElement(Button_1.Button, { key: TaskListDescriptionTypes_1.DATA_TEST_IDS.TASK_LIST_DESCRIPTION_MODAL_CLOSE_BTN, variant: Button_1.ButtonVariant.Primary, onClick: close, "aria-label": t('time_and_attendance_Close'), style: { width: '100%' } }, t('time_and_attendance_Close'))
        ], onCloseButtonClick: close, closeButtonAltText: t('time_and_attendance_Close') },
        react_1.default.createElement(Text_1.Text, null, descriptionFull)));
    return (react_1.default.createElement(View_1.View, { margin: { top: 'S300' } },
        react_1.default.createElement(Text_1.Text, { dataTestId: TaskListDescriptionTypes_1.DATA_TEST_IDS.TASK_LIST_DESCRIPTION, fontSize: 'T200' }, description),
        react_1.default.createElement(Modal_1.WithModal, { renderModal: renderModal }, ({ open }) => (react_1.default.createElement(LearnMoreButton, { onClick: () => {
                openModal(open);
            }, dataTestId: TaskListDescriptionTypes_1.DATA_TEST_IDS.TASK_LIST_DESCRIPTION_LEARN_MORE, variant: Button_1.ButtonVariant.Tertiary, "aria-label": t(`time_and_attendance_TaskList_DescriptionCopy_LearnMore`) }, t(`time_and_attendance_TaskList_DescriptionCopy_LearnMore`))))));
};
exports.TaskListDescription = TaskListDescription;
const LearnMoreButton = (0, Theme_1.styledWithTheme)(Button_1.Button)(({ theme }) => `
  margin-top: ${theme.selectors.space('S200')}px;
`);
